export const selectPhotoSessionDetail = (state) => state.photoSessionDetail;

export const selectHouseLatLng = (state) => ({
  lat: state.photoSessionDetail && state.photoSessionDetail.house && state.photoSessionDetail.house.lat,
  lng: state.photoSessionDetail && state.photoSessionDetail.house && state.photoSessionDetail.house.lng,
});
